import React, { useEffect, useState, useRef, useCallback } from 'react';
import Post from '../../components/Post';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from '../../reducers/auth/auth.selectors';
import { useTranslation } from 'react-i18next';
import { BOOKMARKS, LIKEDPOSTS, PURCHASEDPOSTS, ROOT, PROFILE, USER_PROFILE } from '../../constants/routes';
import {
  selectFeed, selectFeedss,
  selectFeedLastPage,
  selectFeedData,
  selectFeedPage,
  selectIsFetchingFeed,
  selectTotalPosts,
  selectStatistics,
  selectStatisticsView,
} from '../../reducers/feed/feed.selectors';
import { fetchFeed, registeredCard, fetchPost, fetchFeedPost } from '../../reducers/feed/feed.actions';
import Loader from '../../components/Loader';
import { clearFeedActionCreator } from '../../reducers/feed/feed.actionCreators';
import { useLocation, useRouteMatch } from 'react-router-dom';
import RecommendedArtists from 'components/recommended/RecommendedArtists';
import PopularArtists from 'components/popular/PopularArtists';
import { LoadMoreButton } from 'components/generic-components/LoadMoreButton';
import API from '../../API';
import ProfileImageFilter from 'views/profile/settings/profile/ProfileImageFilter';
import ProfileVideoFilter from 'views/profile/settings/profile/ProfileVideoFilter';
import { isVideo } from 'helpers';
import { toggleFollow } from 'reducers/profile/profile.actions';

const Home = ({
  userId,
  showTotal,
  filterValueParams,
  isFetchingProfile,
  isFollowingProfile,
  profileVision,
  currentUser,
  gridItems,
  parentCallback,
  profileCallback,
  handlePostDelete,
  userPhotoVideoObj,
  ...rest
}) => {
  const feed = useSelector(selectFeed);
  const feedsss = useSelector(selectFeedss);
  const statistics = useSelector(selectStatistics);
  const statisticsView = useSelector(selectStatisticsView);
  const location = useLocation();
  const page = useSelector(selectFeedPage);
  const user = useSelector(selectAuthUser);
  const lastPage = useSelector(selectFeedLastPage);
  const totalPosts = useSelector(selectTotalPosts);
  const isFetchingFeed = useSelector(selectIsFetchingFeed);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const [recommended, setRecommended] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [popular, setPopular] = useState([]);
  const [postUserId, setPostUserId] = useState([]);
  const [isComedianProfile, setIsComedianProfile] = useState(true);
  const [card, setCard] = useState(false);
  const timer = useRef();


  const [delay, setDelay] = useState(5000);
  const [isRunning, setIsRunning] = useState(true);

  const [postinterval, setPostinterval] = useState(null);
  const [feedStatus, setFeedStatus] = useState();
  const [mediaStatus, setMediaStatus] = useState(false);
  const [mediaStatusID, setMediaStatusID] = useState(null);
  const onSubmit = (id) => {
    setPostUserId(id)
    if (!isLoading) {
      setIsLoading(true);
      dispatch(toggleFollow(id))
        .catch(err => {
          console.log('toggleFollow error', err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const getParams = () => {
    let params = {};

    if (location.pathname === LIKEDPOSTS) {
      params.type = 'likes';
    }
    if (location.pathname === PURCHASEDPOSTS) {
      params.type = 'purchases';
    }

    if (filterValueParams?.type) {
      params.type = filterValueParams.type;
    }
    if (filterValueParams?.name === 'all') {
      params = {};
    }

    return params;
  };
  const boookmarkFunc = () => {
    dispatch(fetchFeed(null, null, '/posts/bookmarked-posts')).then(resp => {
      setIsLoading(false);
      if (resp) {
        parentCallback(resp.data);
      }
    });
  };

  useEffect(() => {
 

    setIsLoading(true);
    if (location.pathname === BOOKMARKS) {
      boookmarkFunc();
    } else {
      dispatch(fetchFeed(userId ? userId : null, getParams())).then(resp => {
        setIsLoading(false)

        if (resp && (location.pathname.indexOf('profile') > -1 || location.pathname.indexOf('/u/') > -1)) {

          profileCallback(resp.meta);
          if(profileVision === "photos" || profileVision === "videos"){
     
        
                for(let i = 1;i < resp.meta.last_page;i++){
                      let params = getParams();
                      params.page=i+1
                      
                      dispatch(fetchFeed(userId ? userId : null,   params));
                  
                  
                }
              
       
          
          }
        }
      });


    }

    return () => {
      dispatch(clearFeedActionCreator());
    };
  }, [location, filterValueParams, mediaStatusID, postUserId]);


  const fetchRecommended = async (free) => {
    return API.get(`/users/recommended`, { free })
      .then(res => {
        setRecommended(res);
      })
      .catch(err => {
        throw new Error(err);
      });
  };

  const fetchPopular = async () => {
    return API.get('users/popular')
      .then(res => {
        setPopular(res);
      })
      .catch(err => {
        throw new Error(err);
      });
  };

  useEffect(() => {
  }, [feed])
  useInterval(() => {
    if (feed.length > 0) {
      feed.map((el, index) => {
      if (el.media_status !== 'completed' && el.media_status !== "failed"  ) {
            dispatch(fetchFeedPost(el.id))

          }
        })
    }
  }, isRunning ? delay : null);
  function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);


    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }


  useEffect(() => {
    dispatch(registeredCard()).then(
      (resp) => {
        setCard(resp)



      }
    ).catch(err => console.log(err))

    setIsComedianProfile(USER_PROFILE === match.path);
    if (JSON.parse(localStorage.getItem('feed.suggestions.filter')) === true) {

      fetchRecommended('1')
    }
    else {

      fetchRecommended('0')
    }

  }, []);


  // TODO here we should register another call to API to get recommended artists.
  const loadMorePosts = () => {
    let params = getParams();
    params.page = page + 1;
    dispatch(fetchFeed(userId ? userId : null, params));
  };
  const renderRecomendedArtists = index => {
    return (
      (index === 0 || index % 10 === 0) &&
      location.pathname === ROOT && (
        <>
          <RecommendedArtists recommended={recommended} fetchRecommended={fetchRecommended} />
        </>
      )
    );
  };

  const observer = useRef();

  const lastPostElementRef = React.useCallback(
    node => {
      if (isFetchingFeed || lastPage === page) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(post => {
        if (post[0].isIntersecting) {
          loadMorePosts();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isFetchingFeed, loadMorePosts]
  );

  const noVideo = !isLoading && userPhotoVideoObj?.videos === 0 && profileVision === 'videos' && <p className='no-video-photo'>{t('Artist has not Video post yet')}</p>
  
  const noPhoto = !isLoading && userPhotoVideoObj?.images === 0 && profileVision === 'photos' && <p className='no-video-photo'>{t('Artist has not Photo post yet')}</p>

  return (
    <div className={`bokmark-wrapper col-12 col-md-9 `}>

      <Loader isLoadin={isLoading} height={160} size={30}>
        {!!showTotal && (
          <h5 className="font-weight-bold text-light mx-lg-5 mb-3">
            {totalPosts} {t('Posts')}
          </h5>
        )}
        {statisticsView ? (
          <div className="posts-list-container">
            {Object.keys(statistics).map(statistic => (
              <div className="statistic-container">
                <span className="value">{statistics[statistic]}</span>
                <span className="label">{statistic.replace(/_/g, ' ')}</span>
              </div>
            ))}
          </div>
        ) : feed.length ? (
          <div
            className={`${profileVision === 'photos' || (profileVision === 'videos' && !gridItems)
              ? 'posts-img-video-container'
              : 'posts-list-container'
              }`}
            style={{ display: gridItems ? 'flex' : 'grid', flexDirection: gridItems && 'column' }}
            id={location.pathname === ROOT && 'homepage-wrap'}
          >
            {feed.map((el, index) => (
              <>
                <div
                  ref={feed.length === index + 1 ? lastPostElementRef : null}
                  key={'post' + el.id}
                  className={`${!!profileVision && !gridItems ? 'd-none' : ''}`}
                >


                  {!(profileVision === 'photos') && !(profileVision === 'videos') && (
                    <React.Fragment>
                      {renderRecomendedArtists(index)}
                      <Post
                        handlePostDelete={handlePostDelete}
                        boookmarkFunc={boookmarkFunc}
                        userId={userId}
                        key={index}
                        isFollowingProfile={el.following}
                        post={el}
                        card={card}
                        onSubmit={onSubmit}
                      />
                    </React.Fragment>
                  )}
                </div>
                <>
                  {!isFetchingProfile && (isFollowingProfile || !!currentUser) && profileVision === 'photos' ? (
                    gridItems && !isVideo(el?.files[0]?.orig_src) && el?.files.length > 0 ? (
                      <Post
                        handlePostDelete={handlePostDelete}
                        fetchFeed={fetchFeed}
                        userId={userId}
                        key={index}
                        card={card}
                        onSubmit={onSubmit}
                        isFollowingProfile={el.following}
                        post={el}
                      />
                    ) : (
                      <>
                        <ProfileImageFilter files={el.files} />
                      </>
                    )
                  ) : !isFetchingProfile && (isFollowingProfile || !!currentUser) && profileVision === 'videos' ? (
                    gridItems && isVideo(el?.files[0]?.orig_src) ? (
                      <Post
                        handlePostDelete={handlePostDelete}
                        fetchFeed={fetchFeed}
                        userId={userId}
                        key={index}
                        post={el}
                        card={card}
                        onSubmit={onSubmit}
                        isFollowingProfile={el.following}
                      />
                    ) : (
                      <>
                        <ProfileVideoFilter files={el.files} />
                      </>
                    )
                  ) : null}
                </>
              </>
            ))}
          </div>
        ) : (
          renderRecomendedArtists(0)
        )}

        {noVideo || noPhoto}
        
        <Loader isLoadin={isFetchingFeed && feed.length} style={{ paddingBottom: '40px' }} height={50} size={30}></Loader>
      </Loader>
    </div>
  );
};

export default Home;
